<template lang="html">
  <div v-if="improvements" class="container">
    <div class="row">
        <div class="col s12">
            <a @click.prevent="load('déclarée')" class="green accent-3 waves-effect waves-light btn-small">Déclarées</a>
            <a @click.prevent="load('ouverte')" class="cyan accent-4 waves-effect waves-light btn-small">Ouvertes</a>
            <a @click.prevent="load('en cours')" class="orange lighten-2 waves-effect waves-light btn-small">En cours</a>
            <a @click.prevent="loadAll" class="grey waves-effect waves-light btn-small">Toutes</a>
            <!-- <a class="waves-effect waves-light btn-small">Statut 5</a> -->
        </div>

<!-- <div>
    <download-excel
        :data = "json_data"
        :fields = "json_fields"

    >
        download data
    </download-excel>
</div> -->
        <div class="col s12">
            <table class="responsive-table highlight">
                <thead>
                    <tr>
                        <th>Statut</th>
                        <th>Ref</th>
                        <th>Création</th>
                        <th>Réalisation</th>
                        <th>Utilisateur</th>
                        <th>Objet</th>
                        <th>Situation</th>
                        <th>Proposition</th>
                        <th>Editer</th>
                        <th>Màj</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="improvement in improvements">
                        <td class="" v-bind:class="{'cyan accent-4': improvement.state=='ouverte',
                                                    'orange lighten-2': improvement.state=='en cours',
                                                    'green accent-3': improvement.state=='déclarée' }"
                        >{{improvement.state}}</td>
                        <td>{{improvement.ref | ref}}</td>
                        <td>{{improvement.created_at | formatDate}}</td>
                        <td v-if="(improvement.due_at)">{{improvement.due_at | formatDate }}</td>
                        <td v-else>--/--/----</td>
                        <td>{{improvement.user}}</td>
                        <td>{{improvement.object}}</td>
                        <td>{{improvement.situation}}</td>
                        <td>{{improvement.proposal | shorten}}</td>
                        <td><router-link :to="{ name: 'EditImprovement', params: {ref: improvement.ref} }">
                            <i class="material-icons edit">edit</i>
                        </router-link></td>
                        <td>{{improvement.updated_at | formatDate}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
  </div>
</template>

<script>
import db from '@/firebase/init'
import moment from 'moment'
import 'moment/locale/fr'

export default {
    name: 'NewImprovements',
    data(){
        return{
            improvements: [],
            count: '',
            json_fields:{
                'Statut': 'status',
                'Ref': 'ref',
                'Date': 'created_at',
                'Utilisateur': 'user',
                'Objet': 'object',
                'Situation': 'situation',
                'Proposition': 'proposal',
                'Màj': 'updated_at'
            },
            json_data:[
                {
                    'status': 'anything',
                    'ref': 'agjhga',
                    'created_at': 'mlkckd',
                    'user': 'me',
                    'object': 'ghkdjh',
                    'situation': 'mlkmfl',
                    'proposal': 'mlkmdeedee',
                    'updated_at': 'neve'
                },
                {
                    'status': 'numbre 2',
                    'ref': 'agjhdlkjdga',
                    'created_at': 'dpdoidpdeode',
                    'user': 'dejdldkdjdj',
                    'object': 'edpoiedpoide',
                    'situation': 'edjjlkjfjerd',
                    'proposal': 'rfpoipoirfirfe',
                    'updated_at': 'ropoirfiirfi'
                }
            ],
            json_meta: [
                [
                    {
                        'key': 'charset',
                        'value': 'utf-8'
                    }
                ]
            ]
        }
    },
    filters: {
        formatDate: function(value) {
            if (value) {
                return moment(value).locale('fr').format('L')
            }
        }
    },
    methods:{
        load(e){
            // console.log(e)
            this.improvements = []
            let ref = db.collection('improvements')
            ref.where('state', '==', e).orderBy('created_at').get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    let improvement = doc.data()
                    improvement.id = doc.id
                    this.improvements.push(improvement)

                })
            }).then(() => {
                this.improvements.reverse()
            })
        },
        loadAll(){
            this.improvements = []
            let ref = db.collection('improvements')
            ref.orderBy('created_at').get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    let improvement = doc.data()
                    improvement.id = doc.id
                    if(improvement.state == 'déclarée' || improvement.state == 'en cours' || improvement.state == 'ouverte')
                    {
                        this.improvements.push(improvement)
                    }
                })
            }).then(() => {
                this.improvements.reverse()
            })
        }
    },
    created(){
        // get unvalidated improvements
        let ref = db.collection('improvements')
        ref.orderBy('created_at').get()
        .then(snapshot => {
            snapshot.forEach(doc => {
                let improvement = doc.data()
                improvement.id = doc.id
                if(improvement.state == 'déclarée' || improvement.state == 'en cours' || improvement.state == 'ouverte')
                {
                    this.improvements.push(improvement)
                }
            })
        }).then(() => {
            this.improvements.reverse()
        })
    }
}
</script>

<style lang="css" scoped>
td a {
    cursor: pointer;
}
</style>
